/**
 * Standardised cancellation policy options.
 * Used across onboarding, dashboard, booking panel, and provider profile.
 */
export const CANCELLATION_POLICIES = [
  {
    id: 'flexible',
    label: 'Flexible',
    summary: 'Free cancellation up to 24 hours before',
    detail: 'Full refund of deposit if cancelled at least 24 hours before the appointment. No refund for late cancellations.',
  },
  {
    id: 'moderate',
    label: 'Moderate',
    summary: '50% refund up to 48 hours before',
    detail: '50% deposit refund if cancelled at least 48 hours before the appointment. No refund after that.',
  },
  {
    id: 'strict',
    label: 'Strict',
    summary: 'Non-refundable once booked',
    detail: 'Deposit is non-refundable once the booking is confirmed.',
  },
];

/**
 * Look up a policy by ID. Falls back gracefully for legacy types.
 */
export function getPolicy(policyType) {
  if (!policyType) return CANCELLATION_POLICIES[0]; // default to Flexible
  // Map legacy types
  if (policyType === 'flexible_24h') return CANCELLATION_POLICIES[0];
  if (policyType === 'flexible_48h') return CANCELLATION_POLICIES[1];
  if (policyType === 'custom') return CANCELLATION_POLICIES[0];
  return CANCELLATION_POLICIES.find(p => p.id === policyType) || CANCELLATION_POLICIES[0];
}
